import React from 'react';
import Layout from '../templates/DefaultLayout';
import ResourceDocuments from './ResourceDocuments';
import SystemsSearched from './SystemsSearched';

const SiteAdminPage = () => {

    return (
        <Layout title="Site Administration" subtitle="">
            <div className="container flex flex-col py-4">
                <ResourceDocuments/>
                <SystemsSearched />
            </div>
        </Layout>
    );
};

export default SiteAdminPage;